module.exports = __webpack_public_path__ + "img/positiveCard.d9333b41.png";